import { useSelector } from 'react-redux';

import * as actions from '+/actions';
import * as apiCalls from '+/utils/apiCalls';

import useFetch from './useFetch';

const fetchAllActionTypeMappings = async dispatch => {
  const allActionTypeMappingsData = await apiCalls.getAllActionTypeMappings();
  if (allActionTypeMappingsData.errors) return;
  dispatch(actions.setAllActionTypeMappings(allActionTypeMappingsData));
};

const useAllActionTypeMappings = (refetch = false, id = null) => {
  const allActionTypeMappings = useSelector(state => state.actionTypeMappings.all);

  const shouldFetch = refetch || !allActionTypeMappings || (allActionTypeMappings.isEmpty && allActionTypeMappings.isEmpty());

  useFetch(fetchAllActionTypeMappings, shouldFetch);

  if (id) {
    return allActionTypeMappings?.store?.find(map => map.actionTypeTemplateId === id);
  }

  return allActionTypeMappings;
};

export default useAllActionTypeMappings;
